export default "__VITE_ASSET__05f14af4__"